import { gql } from "@apollo/client";

export const CLERKS_BY_ORGANIZATION = gql`
  query ClerksByOrganizer($where: users_bool_exp) {
    users(where: $where, order_by: { username: asc }) {
      id
      username
    }
  }
`;
